import {
  SETTINGS_JOB_STATUS_CLEAR_SNACKBAR,
  SETTINGS_GET_JOB_STATUS,
  SETTINGS_GET_JOB_STATUS_LOADING,
  SETTINGS_DELETE_JOB_STATUS_SUCCESS,
  SETTINGS_ADD_JOB_STATUS_SUCCESS,
  SETTINGS_ADD_JOB_STATUS_ERROR,
  SETTINGS_JOB_STATUS_ERROR,
} from "../constants/types";

const initialState = {
  jobStatus: [],
  loading: true,
  status: "success",
  text: "",
  showSnackbar: false,
};

const jobStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_JOB_STATUS_CLEAR_SNACKBAR:
      return {
        ...state,
        showSnackbar: false,
      };
    case SETTINGS_GET_JOB_STATUS:
      return {
        ...state,
        ...action.payload,
        showSnackbar: false,
      };
    case SETTINGS_GET_JOB_STATUS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SETTINGS_DELETE_JOB_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_JOB_STATUS_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_ADD_JOB_STATUS_ERROR:
      return {
        ...state,
        ...action.payload,
      };
    case SETTINGS_JOB_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        status: action.payload.status,
        text: action.payload.text,
        showSnackbar: true,
      };

    default:
      return state || {};
  }
};

export default jobStatusReducer;
